export const marketplace = {
  marketplaceSearchInputPlaceholderTitle: 'Hledat',
  marketplaceDetailsCurtainCopyOptionTitle: 'Kopírovat odkaz',
  marketplaceDetailsCurtainFlagOptionTitle: 'Nahlásit obsah',
  marketplaceDetailsCurtainCopiedAlertText: 'Odkaz zkopírován!',
  marketplaceDetailsFlagCurtainTitle: 'Nahlásit',
  marketplaceReportedCurtainContent: 'Obsah nahlášen',
  marketplaceAllItems: 'Všechny položky',
  marketplaceWantToBuy: 'Chci koupit {item} z {appname}'
}
